export const FEED_ENTRY_TYPES = Object.freeze({
  activity: 'activity',
  post: 'post',
  fancyPromo: 'fancy_promo',
  performanceGoalCreated: 'performance_goal_created',
  challenge: 'challenge',
  simplePromo: 'simple_promo',
  groupActivity: 'group_activity',
  suggestedActivity: 'suggested_activity',
  club: 'club'
});

// Used with intersection observer's rootMargins variable to specify when video
// autoplay starts playing
export const AUTOPLAY_MARGIN_TOP = 360;

export const FEED_PAGES = Object.freeze({
  dashboard: 'dashboard',
  club: 'club',
  club_posts: 'club_posts',
  profile: 'profile',
  athlete: 'athlete'
});
